import type { CSSProperties as CSS, HTMLProps } from 'react';
import React, { useEffect, useMemo, useState } from 'react';

import useTimedLoop from '../../hooks/FutureUHL/timers/useTimedLoop';
import { PROGRESS_BAR_UPDATE_INTERVAL_SEC as UPDATE_SEC } from './constants';

export type Props = {
  getNext: () => number, // returns percentage expected to be complete after the NEXT update
  updateSec?: number, // in seconds
} & HTMLProps<HTMLDivElement>;

const ProgressBar = ({
  getNext,
  updateSec = UPDATE_SEC,
  style,
  ...divProps
}: Props) => {
  const [next, setNext] = useState(0);
  const { start: startUpdates, stop: stopUpdates } = useTimedLoop(() => {
    setNext(getNext());
  }, updateSec);

  useEffect(() => {
    startUpdates();
    return stopUpdates;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- only run on load
  }, []);

  const barStyle = useMemo(() => ({
    width: `${next}%`,
    height: '0.375rem',
    transition: `width ${updateSec}s linear`,
    backgroundColor: '#006FCF',
    ...style || {},
  }), [next, style, updateSec]) satisfies CSS;

  return <div style={barStyle} {...divProps} />;
};

export default ProgressBar;
